import ReactDOM from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'
import './theme/globals.css'
import './i18n/config'

import App from './App.tsx'
import { store } from './store'

import '@/utils/axiosInterceptor'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </>
)
